
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gjr93", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $ygGKm = parcelRequire("ygGKm");


var $iUl0E = parcelRequire("iUl0E");

const $574c86f95ed7997c$var$state = (0, $1P1Tu.createStore)({
    initialState: {
        highlightActionsEditorPlaceholder: null
    },
    actions: {
        setHighlightActionsEditorPlaceholder: (highlightActionsEditorPlaceholder)=>({ setState: setState })=>{
                setState({
                    highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder
                });
            }
    }
});
const $574c86f95ed7997c$export$e638cf26ae51308d = (0, $9zUhf.createHook)($574c86f95ed7997c$var$state);
const $574c86f95ed7997c$var$getHighlightActionPlaceholderData = (prompt, placeholderText)=>{
    const promptContent = (0, $ygGKm.appendADFContent)(prompt, placeholderText);
    return promptContent;
};
const $574c86f95ed7997c$export$21b2d5ca0689f678 = ()=>{
    const [{ highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder }, { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder }] = $574c86f95ed7997c$export$e638cf26ae51308d();
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const insertHighlightActionsEditorPlaceholder = (0, $42omo.useCallback)((prompt)=>{
        const highlightActionsPlaceholderPrompt = formatMessage((0, $iUl0E.default).highlightActionsPlaceholderPrompt);
        const placeholderData = $574c86f95ed7997c$var$getHighlightActionPlaceholderData(prompt, highlightActionsPlaceholderPrompt);
        setHighlightActionsEditorPlaceholder(placeholderData);
    }, [
        setHighlightActionsEditorPlaceholder,
        formatMessage
    ]);
    const clearHighlightActionsEditorPlaceholder = (0, $42omo.useCallback)(()=>{
        setHighlightActionsEditorPlaceholder(null);
    }, [
        setHighlightActionsEditorPlaceholder
    ]);
    return {
        highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
    };
};
module.exports["useHighlightActionsEditorPlaceholder"] = $574c86f95ed7997c$export$21b2d5ca0689f678;

});

parcelRegister("ygGKm", function(module, exports) {
const $604298656c254432$export$f00236a854eaa848 = (content, suggestionContent)=>{
    const updatedContent = Array.isArray(content.content) ? content.content : [
        content.content
    ];
    // Append the new paragraph node
    updatedContent.push({
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: suggestionContent
            }
        ]
    });
    // Return the updated DocNode
    return {
        ...content,
        content: updatedContent
    };
};
module.exports["appendADFContent"] = $604298656c254432$export$f00236a854eaa848;

});

parcelRegister("iUl0E", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $2fd64f51ce2261f9$var$_default_1 = (0, $h82at.defineMessages)({
    highlightActionsPlaceholderPrompt: {
        id: "highlight-actions.rovo-chat.placeholder-prompt",
        defaultMessage: "Ask a question about this."
    }
});
var $2fd64f51ce2261f9$export$2e2bcd8739ae039 = $2fd64f51ce2261f9$var$_default_1;
module.exports["default"] = $2fd64f51ce2261f9$export$2e2bcd8739ae039;

});

parcelRegister("i1Nyn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");

const $3527ba50fc1c4fde$export$6f57813fe9f31bf9 = (0, $1P1Tu.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        slidesContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        aiFeatureContext: {},
        contentTargets: {},
        currentTargetId: undefined,
        pageSmartLinks: undefined
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const currentAIFeatureContextState = getState().aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getJiraCreateContext: ()=>({ getState: getState })=>getState().jiraCreateContext,
        setJiraCreateContext: (jiraCreateContext)=>({ setState: setState })=>{
                setState({
                    jiraCreateContext: jiraCreateContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getSlidesContext: ()=>({ getState: getState })=>getState().slidesContext,
        setSlidesContext: (slidesContext)=>({ setState: setState })=>{
                setState({
                    slidesContext: slidesContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        mergeDatabaseContext: (partial)=>({ getState: getState, setState: setState })=>{
                // If no selected elements published, clean up the database context
                if (!partial?.selectedElementIds) {
                    setState({
                        databaseContext: undefined
                    });
                    return;
                }
                const current = getState().databaseContext;
                setState({
                    databaseContext: current ? {
                        ...current,
                        ...partial
                    } : partial
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        setPageSmartLinks: (pageSmartLinks)=>({ setState: setState })=>{
                setState({
                    pageSmartLinks: pageSmartLinks
                });
            },
        getTarget: (contentContext, activeTargetId)=>({ getState: getState })=>{
                const targets = getState().contentTargets[contentContext];
                if (!targets) return undefined;
                if ((0, $dh538.fg)('aifc_multiple_context')) {
                    // New mode: targets is always an array
                    const targetList = targets;
                    // If activeTargetId provided, find it; otherwise return first target
                    if (activeTargetId) return targetList.find((t)=>t.id === activeTargetId);
                    return targetList[0];
                }
                // Legacy mode: single target
                return targets;
            },
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                for (const [context, targets] of entries){
                    const targetList = (0, $dh538.fg)('aifc_multiple_context') ? targets : [
                        targets
                    ];
                    if (targetList.some((t)=>t.id === contentId)) return context;
                }
                return undefined;
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const entries = getState().contentTargets;
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                if (entries['staging-area']) return 'staging-area';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                const currentTargets = getState().contentTargets;
                if ((0, $dh538.fg)('aifc_multiple_context')) {
                    // New mode: store as array, append if not already present
                    const existing = currentTargets[toAdd];
                    const targetList = existing ?? [];
                    // Avoid duplicates by checking if target with same id exists
                    // & filter out any targets with empty IDs to avoid stale targets
                    const filtered = targetList.filter((t)=>t.id !== '' && t.id !== target.id);
                    filtered.push(target);
                    setState({
                        contentTargets: {
                            ...currentTargets,
                            [toAdd]: filtered
                        }
                    });
                } else // Legacy behavior: single target
                setState({
                    contentTargets: {
                        ...currentTargets,
                        [toAdd]: target
                    }
                });
            },
        clearTarget: (toRemove, targetId)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k !== toRemove) nextState[k] = currentState[k];
                    else if (targetId && (0, $dh538.fg)('aifc_multiple_context')) {
                        // If multiple-context mode with a specific targetId, filter out that target
                        const targetList = currentState[k];
                        const filtered = targetList.filter((t)=>t.id !== targetId);
                        if (filtered.length > 0) nextState[k] = filtered;
                    }
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId
    }
});
const $3527ba50fc1c4fde$export$53bf948a400e8426 = (0, $9zUhf.createActionsHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9);
const $3527ba50fc1c4fde$export$9465f65715425f1b = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $3527ba50fc1c4fde$export$eea520981851a092 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $3527ba50fc1c4fde$export$c517e9a5e436c401 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.slidesContext
});
const $3527ba50fc1c4fde$export$debe3dc2612d2a8e = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.databaseContext
});
const $3527ba50fc1c4fde$export$376b2a7bf70dad8 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $3527ba50fc1c4fde$export$6280f21050465fe4 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageSmartLinks
});
const $3527ba50fc1c4fde$export$3794ec8d9f571031 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.aiFeatureContext
});
const $3527ba50fc1c4fde$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext })=>{
    const actions = $3527ba50fc1c4fde$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $42omo.useCallback)(async (type, contentContext, activeTargetId)=>{
        const currentTargetId = getCurrentTargetId();
        // Only use activeTargetId when aifc_multiple_context is enabled
        const targetId = (0, $dh538.fg)('aifc_multiple_context') ? activeTargetId : undefined;
        const contentTarget = getTarget(contentContext, targetId);
        if (!contentTarget) return undefined;
        // Only use currentTargetId when staging-area doesn't exist
        // to avoid changing any content open behind the staging
        // area modal
        const shouldUseCurrentTargetId = type === 'page' && !getTarget('staging-area');
        const selectedTargetId = shouldUseCurrentTargetId ? currentTargetId || contentTarget.id : contentTarget.id;
        const contentBody = await getContentBody(type, selectedTargetId);
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                if (!contentBody.pageBody) return undefined;
                return {
                    contentId: contentBody.contentId,
                    document: {
                        type: 'text/adf',
                        content: contentBody.pageBody
                    },
                    selection: {
                        type: 'text/markdown',
                        content: contentBody.selectionMarkdown || ''
                    },
                    selectionFragment: contentBody.selectionFragment,
                    selectionLocalIds: contentBody.selectionLocalIds,
                    contentMauiId: contentBody.contentMauiId,
                    dynamicUiSource: contentBody.dynamicUiSource,
                    dynamicUiType: contentBody.dynamicUiType,
                    mediaFileId: contentBody.mediaFileId,
                    isViewMode: contentBody.isViewMode,
                    useGenericEditorSkill: contentBody.useGenericEditorSkill,
                    additionalContext: contentBody.additionalContext
                };
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'slide':
                if (!contentBody.xml) return undefined;
                return {
                    contentId: contentBody.contentId,
                    xml: contentBody.xml,
                    title: contentBody.title,
                    url: contentBody.url,
                    selectedSlideIndex: contentBody.selectedSlideIndex,
                    selectedElementIds: contentBody.selectedElementIds
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url
                };
            case 'dashboard':
                if (!contentBody.content) return undefined;
                return {
                    content: contentBody.content,
                    dashboardAri: contentBody.dashboardAri,
                    isEditing: contentBody.isEditing
                };
            default:
                return undefined;
        }
    }, [
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getEditorContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('page', contentContext, activeTargetId) : actions.getEditorContext();
    }, [
        actions,
        fetchContent
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getWhiteboardContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('whiteboard', contentContext, activeTargetId) : actions.getWhiteboardContext();
    }, [
        actions,
        fetchContent
    ]);
    const getSlidesContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $c6GJD.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false);
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('slide', contentContext, activeTargetId) : actions.getSlidesContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('database', contentContext, activeTargetId) : actions.getDatabaseContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDashboardEditorContext = (0, $42omo.useCallback)(async ({ contentContext: contentContext, activeTargetId: activeTargetId })=>{
        if (!(0, $dh538.fg)('platform_avp_aifc_enabled')) return undefined;
        return await fetchContent('dashboard', contentContext, activeTargetId);
    }, [
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $42omo.useCallback)(({ contentContext: contentContext, isFirstPrompt: isFirstPrompt })=>{
        if (contentContext === 'staging-area' && !isFirstPrompt && (0, $dh538.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $42omo.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $42omo.useCallback)((addCurrentPageAsContextUserPreference)=>{
        // undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference && useCurrentNonEditingPageAsContext;
    }, [
        useCurrentNonEditingPageAsContext,
        getIsStagingArea
    ]);
    const getBrowserContext = (0, $42omo.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled && !(0, $c6GJD.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference) return undefined;
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        const browserContext = browserContextResult ? {
            context: browserContextResult
        } : actions.getBrowserContext();
        return browserContext;
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $42omo.useCallback)(async ()=>{
        if ((0, $dh538.fg)('jira-aifc-enable-preview-card-in-chat-v2')) {
            const isStagingArea = getIsStagingArea();
            if (!isStagingArea) {
                const jiraCreateContext = actions.getJiraCreateContext();
                if (jiraCreateContext?.draftWorkItems) return jiraCreateContext;
            }
        }
        // Fallback to bridge API if available (staging area doesn't have the state in sync with the chat store)
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext,
        actions,
        getIsStagingArea
    ]);
    return {
        ...actions,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSlidesContext: getSlidesContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getDashboardEditorContext: getDashboardEditorContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $3527ba50fc1c4fde$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
	 * If AIFC is not enabled, we default to the user's preference.
	 */ if (!isAifcEnabled) return userPreference;
    /**
	 * In the staging area, we always want to provide context if the source is the
	 * inline editor, or if the prompt is not the first in a new conversation.
	 */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP' || source === 'CONFLUENCE_CWR_TEMPLATE';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
		 * On real content when AIFC is enabled, we only want to default to true
		 * if the source of the content is the inline editing experience. Otherwise,
		 * we want to respect the preference chosen by the user.
		 */ return sourceEligible || userPreference;
}
module.exports["useChatContextStoreActions"] = $3527ba50fc1c4fde$export$53bf948a400e8426;
module.exports["useChatContextEditorContext"] = $3527ba50fc1c4fde$export$9465f65715425f1b;
module.exports["useChatContextDatabaseContext"] = $3527ba50fc1c4fde$export$debe3dc2612d2a8e;
module.exports["useChatContextBrowserContext"] = $3527ba50fc1c4fde$export$376b2a7bf70dad8;
module.exports["useChatContextPageSmartLinks"] = $3527ba50fc1c4fde$export$6280f21050465fe4;
module.exports["useChatContextAIFeatureContext"] = $3527ba50fc1c4fde$export$3794ec8d9f571031;
module.exports["useChatContextProvider"] = $3527ba50fc1c4fde$export$904052abb7b98535;

});

parcelRegister("4enat", function(module, exports) {
/* ShimmerText.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $iXCQx = parcelRequire("iXCQx");

const $dfdf02a47c71d931$var$shimmerAnimation = null;
const $dfdf02a47c71d931$var$shimmerTextStyle = null;
const $dfdf02a47c71d931$export$f35c7d979dec8662 = ({ children: children, size: size = 'medium', weight: weight = 'regular' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_11q7gl65 _y44vgcf4 _1lrwm4tz _pjrq1kdv _oo9g1j28 _1y1m1kdv"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: size,
            weight: weight,
            color: "color.text.subtlest",
            children: children
        })
    });
};
module.exports["ShimmerText"] = $dfdf02a47c71d931$export$f35c7d979dec8662;

});

parcelRegister("6UNNU", function(module, exports) {
/* ThinkingIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $gdv5Z = parcelRequire("gdv5Z");


var $4enat = parcelRequire("4enat");


var $6nz1O = parcelRequire("6nz1O");


var $jNtYE = parcelRequire("jNtYE");


var $jHHqB = parcelRequire("jHHqB");

const $68998c8ef6b7e73e$var$styles = {
    root: "_4t3i1tcg _1e0c1txw _2lx2vrvc _1bah1e5h _1n261q9c _4cvr1h6o",
    iconContainer: "_zulpu2gc _2hwxv77o _1e0c1txw _4cvr1h6o",
    text: "_11c8fhey _syazi7uo _1nmz1hna",
    textNoWrap: "_11c8fhey _1reo15vq _18m915vq _syazi7uo _o5721q9c",
    ellipsesContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $68998c8ef6b7e73e$var$getLoadingMorphingIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jHHqB.MorphingShapeLoader), {
        testId: "morphing-loader"
    });
};
const $68998c8ef6b7e73e$var$getIcon = (icon)=>{
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(icon)) return icon;
    else if (icon) return /*#__PURE__*/ (0, $l998X.jsx)((0, $jNtYE.LazyAnimatedRovoIcon), {
        alt: "Rovo",
        testId: "rovo-loading-animation",
        width: "24px",
        height: "24px"
    });
    return null;
};
const $68998c8ef6b7e73e$export$cc468b3595726b51 = ({ title: title, isAnimated: isAnimated = true, icon: icon = true, animation: animation = false, showEllipsis: showEllipsis = true, testId: testId })=>{
    const enableAnimation = animation && (0, $c6GJD.default).getExperimentValue('rovo_chat_thinking_traces_improvements', 'isEnabled', false);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $68998c8ef6b7e73e$var$styles.root,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $68998c8ef6b7e73e$var$styles.iconContainer,
                children: [
                    enableAnimation ? $68998c8ef6b7e73e$var$getLoadingMorphingIcon() : $68998c8ef6b7e73e$var$getIcon(icon),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: showEllipsis ? $68998c8ef6b7e73e$var$styles.textNoWrap : $68998c8ef6b7e73e$var$styles.text,
                        children: enableAnimation ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4enat.ShimmerText), {
                            children: title
                        }) : title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $68998c8ef6b7e73e$var$styles.ellipsesContainer,
                children: showEllipsis && /*#__PURE__*/ (0, $l998X.jsx)((0, $6nz1O.EllipsesAnimation), {
                    isAnimated: isAnimated
                })
            })
        ]
    });
};
module.exports["RovoThinkingIndicator"] = $68998c8ef6b7e73e$export$cc468b3595726b51;

});

parcelRegister("6nz1O", function(module, exports) {
/* EllipsesAnimation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $32fc58aca0fb1b9e$var$animation = null;
const $32fc58aca0fb1b9e$var$animation1 = null;
const $32fc58aca0fb1b9e$var$animation2 = null;
const $32fc58aca0fb1b9e$var$dot1 = null;
const $32fc58aca0fb1b9e$var$dot2 = null;
const $32fc58aca0fb1b9e$var$dot3 = null;
const $32fc58aca0fb1b9e$var$animatedOpacity = null;
const $32fc58aca0fb1b9e$export$c0e6915bcce7d1d0 = ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v1gpk",
                    isAnimated && $32fc58aca0fb1b9e$var$animatedOpacity
                ]),
                d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v18gg",
                    isAnimated && $32fc58aca0fb1b9e$var$animatedOpacity
                ]),
                d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44voqx9",
                    isAnimated && $32fc58aca0fb1b9e$var$animatedOpacity
                ]),
                d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
                fill: "#FCA700"
            })
        ]
    });
};
module.exports["EllipsesAnimation"] = $32fc58aca0fb1b9e$export$c0e6915bcce7d1d0;

});

parcelRegister("jNtYE", function(module, exports) {
/* LazyAnimatedRovoIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $d19178c9b9dc2956$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("eOMI9")));
const $d19178c9b9dc2956$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($d19178c9b9dc2956$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});
module.exports["LazyAnimatedRovoIcon"] = $d19178c9b9dc2956$export$7ea4e54699cd5224;

});

parcelRegister("eOMI9", function(module, exports) {

let $ac9b85351e52bf24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac9b85351e52bf24$var$load("2MGzj").then(()=>parcelRequire('boWof'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("jHHqB", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4zBBx = parcelRequire("4zBBx");


var $5Z2H0 = parcelRequire("5Z2H0");

// Module-level state — persists the current frame across remounts
// so the morphing animation continues smoothly without restarting.
let $30495697657ad4f8$var$savedFrame = 0;
let $30495697657ad4f8$var$hasPlayedBefore = false;
const $30495697657ad4f8$var$CONTAINER_STYLE = {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible'
};
const $30495697657ad4f8$var$LOTTIE_WRAPPER_STYLE = {
    width: 16,
    height: 16
};
const $30495697657ad4f8$export$c07a397cf5c24cd8 = ({ testId: testId })=>{
    const containerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const currentRef = containerRef.current;
        if (!currentRef) return;
        const baseAnimationConfig = {
            container: currentRef,
            animationData: (0, (/*@__PURE__*/$parcel$interopDefault($5Z2H0))),
            renderer: 'svg',
            loop: true
        };
        let animationInstance;
        if ($30495697657ad4f8$var$hasPlayedBefore) {
            // Remount — resume from saved frame
            animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($4zBBx))).loadAnimation({
                ...baseAnimationConfig,
                autoplay: false
            });
            animationInstance.goToAndPlay($30495697657ad4f8$var$savedFrame, true);
        } else // First mount — start from scratch
        animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($4zBBx))).loadAnimation({
            ...baseAnimationConfig,
            autoplay: true
        });
        $30495697657ad4f8$var$hasPlayedBefore = true;
        return ()=>{
            // Save current frame before destroying
            $30495697657ad4f8$var$savedFrame = animationInstance.currentFrame;
            animationInstance.destroy();
        };
    }, []);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- static styles for lottie container
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: $30495697657ad4f8$var$CONTAINER_STYLE,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: $30495697657ad4f8$var$LOTTIE_WRAPPER_STYLE,
            ref: containerRef
        })
    }));
};
module.exports["MorphingShapeLoader"] = $30495697657ad4f8$export$c07a397cf5c24cd8;

});

parcelRegister("5Z2H0", function(module, exports) {
module.exports = JSON.parse("{\"v\":\"5.7.1\",\"fr\":30,\"ip\":0,\"op\":108,\"w\":100,\"h\":100,\"nm\":\"Shape Morph\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Morph Shape\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[90],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[180],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[360],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[450]}]},\"p\":{\"a\":0,\"k\":[50,50,0]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":0,\"k\":[100,100,100]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-50,-50],[-41.7,-50],[-33.3,-50],[-25,-50],[-16.700000000000003,-50],[-8.299999999999997,-50],[0,-50],[8.299999999999997,-50],[16.700000000000003,-50],[25,-50],[33.3,-50],[41.7,-50],[50,-50],[50,-41.7],[50,-33.3],[50,-25],[50,-16.700000000000003],[50,-8.299999999999997],[50,0],[50,8.299999999999997],[50,16.700000000000003],[50,25],[50,33.3],[50,41.7],[50,50],[41.7,50],[33.3,50],[25,50],[16.700000000000003,50],[8.299999999999997,50],[0,50],[-8.299999999999997,50],[-16.700000000000003,50],[-25,50],[-33.3,50],[-41.7,50],[-50,50],[-50,41.7],[-50,33.3],[-50,25],[-50,16.700000000000003],[-50,8.299999999999997],[-50,0],[-50,-8.299999999999997],[-50,-16.700000000000003],[-50,-25],[-50,-33.3],[-50,-41.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[5.3999999999999915,-46.9],[10.799999999999997,-43.7],[16.200000000000003,-40.6],[21.700000000000003,-37.5],[27.099999999999994,-34.4],[32.5,-31.2],[37.900000000000006,-28.1],[43.3,-25],[43.3,-18.7],[43.3,-12.5],[43.3,-6.200000000000003],[43.3,0],[43.3,6.299999999999997],[43.3,12.5],[43.3,18.799999999999997],[43.3,25],[37.900000000000006,28.099999999999994],[32.5,31.299999999999997],[27.099999999999994,34.400000000000006],[21.700000000000003,37.5],[16.200000000000003,40.599999999999994],[10.799999999999997,43.8],[5.3999999999999915,46.900000000000006],[0,50],[-5.399999999999999,46.900000000000006],[-10.799999999999997,43.8],[-16.200000000000003,40.599999999999994],[-21.699999999999996,37.5],[-27.1,34.400000000000006],[-32.5,31.299999999999997],[-37.9,28.099999999999994],[-43.3,25],[-43.3,18.799999999999997],[-43.3,12.5],[-43.3,6.299999999999997],[-43.3,0],[-43.3,-6.200000000000003],[-43.3,-12.5],[-43.3,-18.8],[-43.3,-25],[-37.9,-28.1],[-32.5,-31.3],[-27.1,-34.4],[-21.699999999999996,-37.5],[-16.200000000000003,-40.6],[-10.799999999999997,-43.7],[-5.399999999999999,-46.9]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[3.1000000000000014,-43.7],[6.299999999999997,-37.5],[9.399999999999999,-31.2],[12.5,-25],[15.599999999999994,-18.7],[18.799999999999997,-12.5],[21.900000000000006,-6.200000000000003],[25,0],[28.099999999999994,6.299999999999997],[31.299999999999997,12.5],[34.400000000000006,18.799999999999997],[37.5,25],[40.599999999999994,31.299999999999997],[43.8,37.5],[46.900000000000006,43.8],[50,50],[43.8,50],[37.5,50],[31.299999999999997,50],[25,50],[18.799999999999997,50],[12.5,50],[6.299999999999997,50],[0,50],[-6.200000000000003,50],[-12.5,50],[-18.7,50],[-25,50],[-31.2,50],[-37.5,50],[-43.7,50],[-50,50],[-46.9,43.8],[-43.7,37.5],[-40.6,31.299999999999997],[-37.5,25],[-34.4,18.799999999999997],[-31.2,12.5],[-28.1,6.299999999999997],[-25,0],[-21.9,-6.200000000000003],[-18.7,-12.5],[-15.600000000000001,-18.7],[-12.5,-25],[-9.399999999999999,-31.2],[-6.200000000000003,-37.5],[-3.1000000000000014,-43.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}]}]},\"nm\":\"Path\",\"mn\":\"ADBE Vector Shape - Group\"},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433]}]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100}}],\"nm\":\"Shape Group\",\"np\":3}],\"ip\":0,\"op\":108,\"st\":0,\"bm\":0}]}");

});

parcelRegister("9J8UT", function(module, exports) {
/* AIChatIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $8aef4f4f02d5b2fe$var$styles = {
    container: "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1crf _1bsb1crf"
};
const $8aef4f4f02d5b2fe$var$ROVO_SVG_PATH = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L10.7381 2.50115C11.1589 2.7437 11.4193 3.1937 11.4193 3.67848V8.31707C11.4193 8.80377 11.1604 9.25178 10.7385 9.4942L7.71671 11.2376C7.72332 11.219 7.72963 11.2003 7.73565 11.1815C7.79172 11.0077 7.82146 10.8241 7.82146 10.6363V5.99777C7.82146 5.36053 7.4823 4.7729 6.92908 4.45501L6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224Z" fill="#FCA700"/>
		<path d="M4.35709 0.762451L1.33533 2.50585C0.91337 2.74828 0.654541 3.19629 0.654541 3.68299V8.32158C0.654541 8.80636 0.914895 9.25633 1.33561 9.49887L2.05206 9.91223L5.35553 11.8182C5.76872 12.0563 6.27717 12.0606 6.69373 11.8308C6.70128 11.825 6.7093 11.8196 6.71781 11.8147C7.01463 11.6435 7.2317 11.3691 7.33376 11.0521C7.3753 10.9211 7.39725 10.7826 7.39725 10.6409V8.84408L5.64872 7.83569L5.14485 7.54513C4.59174 7.22722 4.25234 6.63946 4.25234 6.00228V1.3637C4.25234 1.17625 4.28199 0.992849 4.33793 0.81927C4.344 0.800208 4.35039 0.781265 4.35709 0.762451Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64872 7.83569L2.05206 9.91223L1.33561 9.49887C0.914895 9.25633 0.654541 8.80636 0.654541 8.32158V3.68299C0.654541 3.19629 0.91337 2.74828 1.33533 2.50585L4.35709 0.762451C4.35039 0.781265 4.344 0.800208 4.33793 0.81927C4.28199 0.992849 4.25234 1.17625 4.25234 1.3637V6.00228C4.25234 6.63946 4.59174 7.22722 5.14485 7.54513L5.64872 7.83569Z" fill="#1868DB"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L6.37094 4.13313Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M10.7381 2.5012L9.9676 2.05664L6.37094 4.13318L6.92907 4.45507C7.48229 4.77296 7.82146 5.36059 7.82146 5.99783V10.6364C7.82146 10.8241 7.79172 11.0078 7.73565 11.1816C7.72963 11.2004 7.72332 11.2191 7.71671 11.2377L10.7385 9.49426C11.1604 9.25184 11.4193 8.80382 11.4193 8.31712V3.67853C11.4193 3.19376 11.1589 2.74376 10.7381 2.5012Z" fill="#AF59E0"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64873 7.83569L2.05206 9.91224L5.35553 11.8182C5.76873 12.0564 6.27718 12.0606 6.69373 11.8308C6.70128 11.825 6.70931 11.8196 6.71782 11.8147C7.01463 11.6436 7.2317 11.3691 7.33377 11.0521C7.37531 10.9211 7.39726 10.7826 7.39726 10.6409V8.84409L5.64873 7.83569Z" fill="#6A9A23"/>
	</svg>`;
const $8aef4f4f02d5b2fe$var$RovoLogoSVG = ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        role: "img",
        "aria-label": label,
        "data-testid": testId,
        dangerouslySetInnerHTML: {
            __html: $8aef4f4f02d5b2fe$var$ROVO_SVG_PATH
        },
        className: (0, $gMc0m.default)([
            $8aef4f4f02d5b2fe$var$styles.container
        ])
    });
const $8aef4f4f02d5b2fe$export$4476d508de061a72 = ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)($8aef4f4f02d5b2fe$var$RovoLogoSVG, {
        label: label,
        testId: testId
    });
module.exports["AIChatIcon"] = $8aef4f4f02d5b2fe$export$4476d508de061a72;

});

parcelRegister("abUsF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");


var $fBMbo = parcelRequire("fBMbo");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $9J8UT = parcelRequire("9J8UT");

var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");


var $c6GJD = parcelRequire("c6GJD");


var $fzqvY = parcelRequire("fzqvY");

var $fb3kw = parcelRequire("fb3kw");


var $ghftu = parcelRequire("ghftu");


var $4fdTR = parcelRequire("4fdTR");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $lBFuf = parcelRequire("lBFuf");


var $i25hX = parcelRequire("i25hX");


var $4noo5 = parcelRequire("4noo5");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $kIvLT = parcelRequire("kIvLT");


var $ygGKm = parcelRequire("ygGKm");


var $gncRT = parcelRequire("gncRT");


var $gjr93 = parcelRequire("gjr93");


var $jmorr = parcelRequire("jmorr");

const $157c507ad23459f7$var$styles = {
    popupContainer: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    formWrapper: "_1pfhx0bf",
    sendIconWrapper: "_y4tiutpp",
    rovoChatMoreOptionsButtonContainer: "_ahbqx0bf",
    rovoChatOpenChatIcon: "_bozgv77o"
};
const $157c507ad23459f7$export$1ccbc9113b239d47 = ({ selectedContent: selectedContent, product: product, onClickChat: onClickChat, onClickPromptOverride: onClickPromptOverride, onSubmitCustomPromptOverride: onSubmitCustomPromptOverride })=>{
    (0, $fBMbo.di)((0, $c6GJD.default), (0, $gncRT.useRovoChatHighlightActions));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { setIsMoreOptionsPopupOpen: setIsMoreOptionsPopupOpen } = (0, $gncRT.useRovoChatHighlightActionsActions)();
    const [{ isMoreOptionsPopupOpen: isMoreOptionsPopupOpen }] = (0, $gncRT.useRovoChatHighlightActions)();
    const { insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder } = (0, $gjr93.useHighlightActionsEditorPlaceholder)();
    (0, $42omo.useEffect)(()=>{
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'contextualMenuItem',
            actionSubjectId: 'rovoChatHighlightActions',
            attributes: {
                product: product
            }
        });
    }, [
        sendAnalyticsEvent,
        product
    ]);
    const onClose = (0, $42omo.useCallback)(()=>{
        setIsMoreOptionsPopupOpen(false);
    }, [
        setIsMoreOptionsPopupOpen
    ]);
    const handleClickChat = (0, $42omo.useCallback)(async ()=>{
        onClickChat();
        insertHighlightActionsEditorPlaceholder(selectedContent);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuRovoChatButton',
            attributes: {
                product: product
            }
        });
    }, [
        onClickChat,
        insertHighlightActionsEditorPlaceholder,
        selectedContent,
        sendAnalyticsEvent,
        product
    ]);
    const handlePromptSubmit = (0, $42omo.useCallback)((values, form)=>{
        const formattedPrompt = (0, $ygGKm.appendADFContent)(selectedContent, values.prompt);
        if (onSubmitCustomPromptOverride) {
            onSubmitCustomPromptOverride(formattedPrompt);
            form.reset();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
                attributes: {
                    product: product
                }
            });
            return;
        }
        publish({
            type: 'chat-new',
            source: `${product}-context-menu`,
            data: {
                name: values.prompt.substring(0, 30),
                dialogues: [],
                prompt: formattedPrompt
            }
        });
        form.reset();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
            attributes: {
                product: product
            }
        });
    }, [
        publish,
        sendAnalyticsEvent,
        product,
        onSubmitCustomPromptOverride,
        selectedContent
    ]);
    const rovoChatPromptOptions = [
        {
            id: 'context-menu-rovo-chat-summarize-option',
            actionType: 'summarize',
            prompt: formatMessage((0, $jmorr.default).rovoChatSummarizePrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatSummarizeOptionText)
        },
        {
            id: 'context-menu-rovo-chat-explain-option',
            actionType: 'explain',
            prompt: formatMessage((0, $jmorr.default).rovoChatExplainPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatExplainOptionText)
        },
        {
            id: 'context-menu-rovo-chat-find-resources-option',
            actionType: 'find-resources',
            prompt: formatMessage((0, $jmorr.default).rovoChatFindResourcesPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatFindResourcesOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-feedback-option',
            actionType: 'give-feedback',
            prompt: formatMessage((0, $jmorr.default).rovoChatGiveFeedbackPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatGiveFeedbackOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-examples-option',
            actionType: 'give-examples',
            prompt: formatMessage((0, $jmorr.default).rovoChatGiveExamplesPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatGiveExamplesOptionText)
        }
    ];
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            testId: "context-menu-rovo-chat-popup",
            xcss: $157c507ad23459f7$var$styles.popupContainer,
            space: "space.150",
            children: [
                rovoChatPromptOptions.map((option)=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.ChatPill), {
                        testId: option.id,
                        onClick: ()=>{
                            const formattedPrompt = (0, $ygGKm.appendADFContent)(selectedContent, option.prompt);
                            if (onClickPromptOverride) {
                                onClickPromptOverride(formattedPrompt);
                                sendAnalyticsEvent({
                                    action: 'clicked',
                                    actionSubject: 'button',
                                    actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                                    attributes: {
                                        actionType: option.actionType,
                                        product: product
                                    }
                                });
                                return;
                            }
                            publish({
                                type: 'chat-new',
                                source: `${product}-context-menu`,
                                data: {
                                    name: option.prompt.substring(0, 30),
                                    dialogues: [],
                                    prompt: formattedPrompt
                                }
                            });
                            sendAnalyticsEvent({
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                                attributes: {
                                    actionType: option.actionType,
                                    product: product
                                }
                            });
                        },
                        children: option.optionText
                    }, option.id);
                }),
                (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                    onSubmit: handlePromptSubmit,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                        name: "prompt",
                        children: ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default // this prevents the highlight actions popup from closing when clicking on the input
                            ), {
                                onClick: (e)=>e.stopPropagation(),
                                ...fieldPropsRest,
                                testId: "context-menu-rovo-chat-custom-prompt",
                                id: "context-menu-rovo-chat-custom-prompt",
                                autoComplete: "off",
                                elemAfterInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $157c507ad23459f7$var$styles.sendIconWrapper,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        testId: "context-menu-rovo-chat-custom-prompt-submit",
                                        isDisabled: !dirty || !value,
                                        label: formatMessage((0, $jmorr.default).rovoChatCustomPromptSubmitButtonText),
                                        type: "submit",
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                                        spacing: "compact"
                                    })
                                }),
                                placeholder: formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder),
                                "aria-label": formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder)
                            })
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                    onSubmit: handlePromptSubmit,
                    children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $157c507ad23459f7$var$styles.formWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)("form", {
                                ...formProps,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    name: "prompt",
                                    children: ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default // this prevents the highlight actions popup from closing when clicking on the input
                                        ), {
                                            onClick: (e)=>e.stopPropagation(),
                                            ...fieldPropsRest,
                                            testId: "context-menu-rovo-chat-custom-prompt",
                                            id: "context-menu-rovo-chat-custom-prompt",
                                            autoComplete: "off",
                                            elemAfterInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $157c507ad23459f7$var$styles.sendIconWrapper,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                                    testId: "context-menu-rovo-chat-custom-prompt-submit",
                                                    isDisabled: !dirty || !value,
                                                    label: formatMessage((0, $jmorr.default).rovoChatCustomPromptSubmitButtonText),
                                                    type: "submit",
                                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                                                    spacing: "compact"
                                                })
                                            }),
                                            placeholder: formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder),
                                            "aria-label": formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder)
                                        })
                                })
                            })
                        })
                })
            ]
        });
    };
    const isToolbarAIFCEnabled = (0, $iu6m9.editorExperiment)('platform_editor_toolbar_aifc', true);
    if (product === 'confluence' && isToolbarAIFCEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: formatMessage((0, $jmorr.default).rovoChatOpenChatTooltip),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $9J8UT.AIChatIcon), {
                label: ""
            }),
            onClick: handleClickChat,
            testId: "context-menu-rovo-chat-button",
            children: formatMessage((0, $jmorr.default).rovoChatAskRovoButtonText)
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: formatMessage((0, $jmorr.default).rovoChatOpenChatTooltip),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    appearance: "subtle",
                    iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            xcss: $157c507ad23459f7$var$styles.rovoChatOpenChatIcon,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                                size: "xsmall"
                            })
                        }),
                    onClick: handleClickChat,
                    testId: "context-menu-rovo-chat-button",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        weight: "medium",
                        children: formatMessage((0, $jmorr.default).rovoChatAskRovoButtonText)
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                placement: "bottom-start",
                isOpen: isMoreOptionsPopupOpen,
                onClose: onClose,
                content: renderPopupContent,
                zIndex: 600,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $157c507ad23459f7$var$styles.rovoChatMoreOptionsButtonContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            ...triggerProps,
                            appearance: "subtle",
                            id: "context-menu-rovo-chat-more-options",
                            testId: "context-menu-rovo-chat-more-options",
                            isTooltipDisabled: false,
                            icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                    ...props,
                                    label: formatMessage((0, $jmorr.default).rovoChatMoreOptionsTooltip),
                                    size: "small"
                                }),
                            label: formatMessage((0, $jmorr.default).rovoChatMoreOptionsTooltip),
                            onClick: ()=>{
                                setIsMoreOptionsPopupOpen(!isMoreOptionsPopupOpen);
                                sendAnalyticsEvent({
                                    action: 'clicked',
                                    actionSubject: 'button',
                                    actionSubjectId: 'highlightActionsMenuRovoChatMoreOptionsButton',
                                    attributes: {
                                        product: product
                                    }
                                });
                            }
                        })
                    })
            })
        ]
    });
};
module.exports["RovoChatHighlightActions"] = $157c507ad23459f7$export$1ccbc9113b239d47;

});

parcelRegister("gncRT", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $0d32633bd323405d$var$store = (0, $1P1Tu.createStore)({
    name: 'RovoChatHighlightActionsStore',
    initialState: {
        isMoreOptionsPopupOpen: false
    },
    actions: {
        setIsMoreOptionsPopupOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isMoreOptionsPopupOpen: isOpen
                });
            }
    }
});
const $0d32633bd323405d$export$6c9cf98a64763bb1 = (0, $9zUhf.createHook)($0d32633bd323405d$var$store);
const $0d32633bd323405d$export$f1e33ed2d48967b4 = (0, $9zUhf.createActionsHook)($0d32633bd323405d$var$store);
module.exports["useRovoChatHighlightActions"] = $0d32633bd323405d$export$6c9cf98a64763bb1;
module.exports["useRovoChatHighlightActionsActions"] = $0d32633bd323405d$export$f1e33ed2d48967b4;

});

parcelRegister("jmorr", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $1ee4456065df4341$var$_default_1 = (0, $h82at.defineMessages)({
    rovoChatAskInChatButtonText: {
        id: "highlight-actions.rovo-chat.ask-in-chat-button-text",
        defaultMessage: "Ask in Chat"
    },
    rovoChatAskRovoButtonText: {
        id: "highlight-actions.rovo-chat.ask-rovo-button-text",
        defaultMessage: "Ask Rovo"
    },
    rovoChatOpenChatTooltip: {
        id: "highlight-actions.rovo-chat-open-chat.tooltip",
        defaultMessage: "Open Chat"
    },
    rovoChatMoreOptionsTooltip: {
        id: "highlight-actions.rovo-chat-more-options.tooltip",
        defaultMessage: "Chat recommendations"
    },
    rovoChatSummarizeOptionText: {
        id: "highlight-actions.rovo-chat-summarize-option.text",
        defaultMessage: "Summarize"
    },
    rovoChatExplainOptionText: {
        id: "highlight-actions.rovo-chat-explain-option.text",
        defaultMessage: "Explain"
    },
    rovoChatFindResourcesOptionText: {
        id: "highlight-actions.rovo-chat-find-resources-option.text",
        defaultMessage: "Find resources"
    },
    rovoChatGiveFeedbackOptionText: {
        id: "highlight-actions.rovo-chat-give-feedback-option.text",
        defaultMessage: "Give feedback"
    },
    rovoChatGiveExamplesOptionText: {
        id: "highlight-actions.rovo-chat-give-examples-option.text",
        defaultMessage: "Give examples"
    },
    rovoChatSummarizePrompt: {
        id: "highlight-actions.rovo-chat-summarize-prompt",
        defaultMessage: "Highlight the key points from this. Focus on essential information and exclude unnecessary details. Provide a concise overview in a single paragraph."
    },
    rovoChatExplainPrompt: {
        id: "highlight-actions.rovo-chat-explain-prompt",
        defaultMessage: "Explain this by rephrasing it and adding additional detail, but use very simple language, short sentences, and provide examples or definitions to any technical terminology used in the original phrasing."
    },
    rovoChatFindResourcesPrompt: {
        id: "highlight-actions.rovo-chat-find-resources-prompt",
        defaultMessage: "Find resources within organizational knowledge only that supports the statements made."
    },
    rovoChatGiveFeedbackPrompt: {
        id: "highlight-actions.rovo-chat-give-feedback-prompt",
        defaultMessage: "Give feedback by reviewing the phrasing of this. Provide commentary on word choice, grammar, punctuation. Be positive and enthusiastic but always provide at least one thing to improve or change."
    },
    rovoChatGiveExamplesPrompt: {
        id: "highlight-actions.rovo-chat-give-examples-prompt",
        defaultMessage: "Give examples of this from organizational resources or public knowledge. If there are no resources to provide attempt to give a metaphorical example that may help someone understand this more."
    },
    rovoChatCustomPromptPlaceholder: {
        id: "highlight-actions.rovo-chat-custom-prompt.placeholder",
        defaultMessage: "Ask AI about this"
    },
    rovoChatCustomPromptSubmitButtonText: {
        id: "highlight-actions.rovo-chat-custom-prompt-submit-button.text",
        defaultMessage: "Send"
    }
});
var $1ee4456065df4341$export$2e2bcd8739ae039 = $1ee4456065df4341$var$_default_1;
module.exports["default"] = $1ee4456065df4341$export$2e2bcd8739ae039;

});


//# sourceMappingURL=UpdateComposer.d82af8c1.js.map
